var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.blocks ? _c('div', {
    staticClass: "card meta"
  }, [_c('div', {
    staticClass: "table_title"
  }, [_c('span', [_vm._v(" BLOCK #" + _vm._s(_vm.startingBlockNumber) + " TO #" + _vm._s(_vm.endingBlockNumber) + " (TOTAL OF " + _vm._s(parseInt(_vm.latestBlockNumber || '0').toLocaleString()) + " BLOCKS) ")])]), _c('section', [_c('EVMBlockRow', {
    attrs: {
      "blocks": _vm.blocks
    }
  })], 1)]) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }